<template>
  <div v-if="includedInSub">
    <div
      v-if="shortCard"
      class="relative border-l-8 h-full bg-white rounded shadow-md border-pink w-full"
      :class="!includedInSub ? 'opacity-50' : isSelected ? 'shadow-xl' : ''"
    >
      <div
        id="card-content"
        class="p-4"
      >
        <div
          id="card-top"
          class="pb-4 border-b-2 border-matte-gray flex justify-start items-center"
        >
          <img
            src="//summitproedu.imgix.net/redesign-assets/new-subscription-assets/virtual-access-icon.png"
            height="100"
            width="100"
            class="mr-4"
            :class="large ? 'h-14 w-14' : 'h-10 w-10'"
          />
          <h5
            v-if="oaIncludeWebinar"
            class="leading-tight text-left"
            :class="large ? 'text-2xl' : ''"
          >
            Online Access + Webinar
          </h5>
          <h5
            v-else
            class="leading-tight text-left"
            :class="large ? 'text-2xl' : ''"
          >
            Virtual Access Subscription
          </h5>
        </div>
        <div
          id="card-bottom"
          class="pt-4 text-center"
        >
          <p
            v-if="shortCard"
            class="text-sm font-bold"
          >
            Unlimited Access to
            {{ metricStore.liveWebinars }}+ Live Webinar and Live Stream Courses
            {{ metricStore.onlineCourses }}+ Online Video and Online Text Courses and
            Monthly Podcasts
          </p>
          <div class="text-center">
            <div
              v-if="discountedPrice.length > 0"
              class="py-4"
            >
              <p
                v-if="!oaIncludeWebinar"
                class="text-sm"
              >
                Only <span class="line-through">${{ pricesStore.virtualAccess }}/year</span>
              </p>
              <p class="text-sm">
                Discounted price: {{ discountedPrice }}!
              </p>
            </div>
            <p
              v-else-if="hidePrice"
              class="py-4"
            />
            <p
              v-else
              class="py-4 text-sm"
            >
              Only ${{ pricesStore.virtualAccess }}/year
            </p>
            <slot name="button" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="relative border-l-8 rounded h-full bg-white shadow-md border-pink w-full"
      :class="!includedInSub ? 'opacity-50' : ''"
    >
      <div
        id="long-card-content"
        class="p-4"
      >
        <div
          id="long-card-top"
          class="pb-4 border-b-2 border-matte-gray"
        >
          <div class="flex justify-start items-center">
            <img
              src="//summitproedu.imgix.net/redesign-assets/new-subscription-assets/virtual-access-icon.png"
              height="100"
              width="100"
              class="mr-4"
              :class="large ? 'h-14 w-14' : 'h-10 w-10'"
            />
            <h5
              class="leading-tight text-left"
              :class="large ? 'text-2xl' : ''"
            >
              Virtual Access Subscription
            </h5>
          </div>
          <p
            v-if="shortCard"
            class="text-sm font-bold text-center pt-4"
          >
            Unlimited Live Webinar, Live Stream, <br />
            Online Video and Online Text Courses and <br />
            Monthly Podcasts
          </p>
        </div>
        <div
          id="long-card-bottom"
          class="text-center"
        >
          <p class="text-sm pb-2 text-left pt-4">
            Unlimited Access to:
          </p>
          <ul class="text-left">
            <li class="text-sm mb-1">
              <span class="font-bold">{{ metricStore.onlineCourses }}+ </span> On-Demand Video & Text Courses
            </li>
            <li class="text-sm mb-1">
              <span class="font-bold">Monthly</span> CE Podcast Episodes
            </li>
            <li class="text-sm mb-1">
              <span class="font-bold"> Certification Series</span> In {{ metricStore.certificationSeries }} Practice Areas
            </li>
            <li class="text-sm mb-1 text-pink">
              <span class="font-bold">{{ metricStore.liveWebinars }}+</span> Live Interactive Webinars Annually
            </li>
            <li class="text-sm mb-1 text-pink">
              <span class="font-bold">{{ metricStore.liveStreams }}+</span> Live Streams Annually
            </li>
          </ul>
          <div v-if="includeHEP">
            <p class="font-bold text-purple text-left">
              <t-icon
                name="check"
                class="text-purple mr-2"
              />Summit HEP
            </p>
          </div>
          <div
            class="absolute bottom-0 right-0 left-0"
            :class="upgradeOffer.length > 0 ? 'py-4' : ''"
          >
            <div
              v-if="upgradeOffer.length > 0"
              class="pb-9"
            >
              <p class="font-bold text-lg">
                {{ upgradeOffer }}
              </p>
            </div>
            <slot name="button" />
            <p
              v-if="group"
              class="py-4 font-bold text-sm"
            >
              Special Group Rates
            </p>
            <p
              v-else-if="hidePrice"
              class="py-4"
            />
            <p
              v-else-if="discountedPrice.length > 0"
              class="py-4 text-sm"
            >
              Only <span class="line-through">${{ pricesStore.virtualAccess }}/year</span>
              <br />
              Discounted price: {{ discountedPrice }}!
            </p>
            <p
              v-else-if="!upgradeOffer.length > 0"
              class="font-bold text-sm"
              :class="includeHEP ? 'py-4' : 'py-2'"
            >
              Only ${{ pricesStore.virtualAccess }}/year
              <span
                v-if="includeHEP"
                class="font-normal"
              >
                <br /> + $9.99/mo (Summit HEP)
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapStores, } from 'pinia';
import { useMetricStore, } from '~/stores/metrics';
import { usePriceStore,} from '~/stores/prices';

export default {
  name: 'VirtualAccess',
  props: {
    shortCard: {
      type: Boolean,
      default: true,
    },
    oaIncludeWebinar: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: true,
    },
    group: {
      type: Boolean,
      default: false,
    },
    hidePrice: {
      type: Boolean,
      default: false,
    },
    includedInSub: {
      type: Boolean,
      default: true,
    },
    discountedPrice: {
      type: String,
      default: '',
    },
    upgradeOffer: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    rewards: {
      type: Boolean,
      default: false,
    },
    includeHEP: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const pricesStore = usePriceStore();
    const metricStore = useMetricStore();
    return { pricesStore, metricStore };
  },
};
</script>
